import Home from "./Components/Home";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Interwarm from "./Components/Interwarm";
import Interwinter from "./Components/Interwinter";
import InterDiffer from "./Components/InterDiffer";
import Intercold from "./Components/Intercold";
import InterRubDiffer from "./Components/InterRubDiffer";
import InterRubWarm from "./Components/InterRubWarm";
import InterRubWinter from "./Components/InterRubWinter";
import Beg1 from "./Components/Beginner/Beg1";
import Begiron from "./Components/Beginner/Begiron";
import BegRub from "./Components/Beginner/BegRub";
import Begnatural from "./Components/Beginner/Begnatural";
import Begirontemp from "./Components/Beginner/Begirontemp";
import Begcomplete from "./Components/Begcomplete";
import Begrubtemp from "./Components/Beginner/Begrubtemp";
import Adv from "./Components/Advanced/Adv";
import Expert from "./Components/Expert/Expert";
import ExTemp1 from "./Components/ExTemp1";
// import ExBase from "./Components/ExBase";
import ExTemp2 from "./Components/ExTemp2";
import ExTemp3 from "./Components/ExTemp3";

import Ceramicwarm from "./Components/Ceramicwarm";
import Ceramicchill from "./Components/Ceramicchill";
import Ceramiccold from "./Components/Ceramiccold";

import Molywarm from "./Components/Molywarm";
import Molycold from "./Components/Molycold";
import Molychill from "./Components/Molychill";

import Interspeed from "./Components/Interspeed";
import Interceramic from "./Components/Interceramic";
import Intercerrub from "./Components/Intercerrub";
import Intercerwarm from "./Components/Intercerwarm";
import Intercerchill from "./Components/Intercerchill";
import NFW from "./Components/NFW";
import Begironceranic from "./Components/Beginner/Begironceranic";
import Begrubceramic from "./Components/Beginner/Begrubceramic";
import Inter from "./Components/Intermediate/Inter";
import Interiron from "./Components/Intermediate/Interiron";
import InterRub from "./Components/Intermediate/InterRub";
import Interrubtemp from "./Components/Intermediate/Interrubtemp";
import Interirontemp from "./Components/Intermediate/Interirontemp";
import Internatural from "./Components/Intermediate/Internatural";
import Interironceranic from "./Components/Intermediate/Interironceranic";
import Interrubceramic from "./Components/Intermediate/Interrubceramic";
import Advvaries from "./Components/Advanced/Advvaries";
import Advvariesspeed from "./Components/Advanced/Advvariesspeed";
import Advwarm from "./Components/Advanced/Advwarm";
import Advwarmspeed from "./Components/Advanced/Advwarmspeed";
import Advchill from "./Components/Advanced/Advchill";
import Advchillspeed from "./Components/Advanced/Advchillspeed";
import Advcold from "./Components/Advanced/Advcold";
import Advcoldspeed from "./Components/Advanced/Advcoldspeed";
import Exp from "./Components/Expert/Exp";
import Expertvaries from "./Components/Expert/Expertvaries";
import Expertvariesspeed from "./Components/Expert/Expertvariesspeed";
import Expertwarm from "./Components/Expert/Expertwarm";
import Expertwarmspeed from "./Components/Expert/Expertwarmspeed";
import Expertchill from "./Components/Expert/Expertchill";
import Expertchillspeed from "./Components/Expert/Expertchillspeed";
import Expertcold from "./Components/Expert/Expertcold";
import Expertcoldspeed from "./Components/Expert/Expertcoldspeed";

import Expert2 from "./Components/Expert/Expert2";
import ExBase from "./Components/Expert/ExBase";
import Exbasewarm from "./Components/Expert/Exbasewarm";
import Exbasechill from "./Components/Expert/Exbasechill";
import Exbasecold from "./Components/Expert/Exbasecold";

import Exsecwarm from "./Components/Expert/Exsecwarm";
import Exsecchill from "./Components/Expert/Exsecchill";
import Exseccold from "./Components/Expert/Exseccold";
import Exsec from "./Components/Expert/Exsec";

import ExFinal from "./Components/Expert/ExFinal";

function App() {
  return (
    <div className="">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home></Home>} />
          <Route path="/intermediate" element={<Inter></Inter>} />
          <Route path="/interiron" element={<Interiron></Interiron>} />
          <Route path="/interrub" element={<InterRub></InterRub>} />
          <Route path="/interrubtemp" element={<Interrubtemp></Interrubtemp>} />
          <Route path="/internatural" element={<Internatural></Internatural>} />
          <Route
            path="/interirontemp"
            element={<Interirontemp></Interirontemp>}
          />
          <Route
            path="/interironceramic"
            element={<Interironceranic></Interironceranic>}
          />
          <Route
            path="/interrubceramic"
            element={<Interrubceramic></Interrubceramic>}
          />


          {/* <Route path="/interdiffer" element={<InterDiffer></InterDiffer>} />
          <Route
            path="/interrubdiffer"
            element={<InterRubDiffer></InterRubDiffer>}
          />
          <Route path="/interrubwarm" element={<InterRubWarm></InterRubWarm>} />
          <Route
            path="/interrubwinter"
            element={<InterRubWinter></InterRubWinter>}
          /> */}

          <Route path="/beg" element={<Beg1></Beg1>} />
          <Route path="/begiron" element={<Begiron></Begiron>} />
          <Route path="/begrub" element={<BegRub></BegRub>} />
          <Route path="/begrubtemp" element={<Begrubtemp></Begrubtemp>} />
          <Route path="/begnatural" element={<Begnatural></Begnatural>} />
          <Route path="/begirontemp" element={<Begirontemp></Begirontemp>} />
          <Route
            path="/begironceramic"
            element={<Begironceranic></Begironceranic>}
          />
          <Route
            path="/begrubceramic"
            element={<Begrubceramic></Begrubceramic>}
          />

          <Route path="/begcomplete" element={<Begcomplete></Begcomplete>} />

          <Route path="/advance" element={<Adv></Adv>} />
          <Route path="/advvaries" element={<Advvaries></Advvaries>} />
          <Route
            path="/advvariesspeed"
            element={<Advvariesspeed></Advvariesspeed>}
          />
          <Route path="/advwarm" element={<Advwarm></Advwarm>} />
          <Route path="/advwarmspeed" element={<Advwarmspeed></Advwarmspeed>} />
          <Route path="/advchill" element={<Advchill></Advchill>} />
          <Route
            path="/advchillspeed"
            element={<Advchillspeed></Advchillspeed>}
          />
          <Route path="/advcold" element={<Advcold></Advcold>} />
          <Route path="/advcoldspeed" element={<Advcoldspeed></Advcoldspeed>} />

          <Route path="/expert" element={<Exp></Exp>} />
          <Route path="/expert1" element={<Expert></Expert>} />
          <Route path="/expertvaries" element={<Expertvaries></Expertvaries>} />
          <Route
            path="/Expertvariesspeed"
            element={<Expertvariesspeed></Expertvariesspeed>}
          />
          <Route path="/Expertwarm" element={<Expertwarm></Expertwarm>} />
          <Route
            path="/Expertwarmspeed"
            element={<Expertwarmspeed></Expertwarmspeed>}
          />
          <Route path="/Expertchill" element={<Expertchill></Expertchill>} />
          <Route
            path="/Expertchillspeed"
            element={<Expertchillspeed></Expertchillspeed>}
          />
          <Route path="/Expertcold" element={<Expertcold></Expertcold>} />
          <Route
            path="/Expertcoldspeed"
            element={<Expertcoldspeed></Expertcoldspeed>}
          />

          <Route path="/expert2" element={<Expert2></Expert2>} />
          <Route path="/expertbase" element={<ExBase></ExBase>} />
          <Route path="/expertbasewarm" element={<Exbasewarm></Exbasewarm>} />
          <Route
            path="/expertbasechill"
            element={<Exbasechill></Exbasechill>}
          />
          <Route path="/expertbasecold" element={<Exbasecold></Exbasecold>} />

          <Route path="/expertsecond" element={<Exsec></Exsec>} />
          <Route path="/expertsecwarm" element={<Exsecwarm></Exsecwarm>} />
          <Route path="/expertsecchill" element={<Exsecchill></Exsecchill>} />
          <Route path="/expertseccold" element={<Exseccold></Exseccold>} />

          <Route path="/expertfinal" element={<ExFinal></ExFinal>} />

          <Route path="/experttemp1" element={<ExTemp1></ExTemp1>} />
          <Route path="/experttemp2" element={<ExTemp2></ExTemp2>} />
          <Route path="/experttemp3" element={<ExTemp3></ExTemp3>} />

          <Route path="/excerwarm" element={<Ceramicwarm></Ceramicwarm>} />
          <Route path="/excerchill" element={<Ceramicchill></Ceramicchill>} />
          <Route path="/excercold" element={<Ceramiccold></Ceramiccold>} />
          <Route path="/nfw" element={<NFW></NFW>} />

          <Route path="/molywarm" element={<Molywarm></Molywarm>} />
          <Route path="/molychill" element={<Molychill></Molychill>} />
          <Route path="/molycold" element={<Molycold></Molycold>} />

          <Route path="/interspeed" element={<Interspeed></Interspeed>} />
          <Route path="/interceramic" element={<Interceramic></Interceramic>} />
          <Route path="/intercerrub" element={<Intercerrub></Intercerrub>} />
          <Route
            path="/intercerchill"
            element={<Intercerchill></Intercerchill>}
          />
          <Route path="/intercerwarm" element={<Intercerwarm></Intercerwarm>} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;



// https://www.zumwax.com/products/

//  https://www.zumwax.com/products/iron-on-ski-snowboard-nordic-cross-country-wax

// universal iron

// https://www.zumwax.com/products/rub-on-ski-snowboard-nordic-cross-country-wax

//uni rub

// onClick={() => handle("

// https://www.zumwax.com/products/iron-on-ski-snowboard-nordic-base-prep-wax

// base

// https://www.zumwax.com/products/iron-on-ski-snowboard-nordic-cross-country-wax-for-chill-conditions

//Chill Iron

// https://www.zumwax.com/products/iron-on-ski-snowboard-nordic-cross-country-wax-for-cold-conditions

// cold iron

// https://www.zumwax.com/products/iron-on-ski-snowboard-nordic-cross-country-wax-for-warm-conditions

// warm iron

// https://www.zumwax.com/products/all-natural-biodegradable-ski-racing-wax

// natural

// https://www.zumwax.com/products/nfw-universal-rub-on-paste-wax

// nfw paste

// https://www.zumwax.com/products/iron-on-ski-snowboard-nordic-ceramic-wax-for-warmtemp

// iron cermaic warm

// https://www.zumwax.com/products/iron-on-ski-snowboard-nordic-ceramic-wax-for-cold-temp

// iron cermaic cold

// https://www.zumwax.com/products/iron-on-ski-snowboard-nordic-ceramic-wax

// uni iron cermaic

// https://www.zumwax.com/products/ski-snowboard-ceramic-non-fluoro-rub-on-racing-wax 

// uni rub ceramic

// https://www.zumwax.com/products/rub-on-ski-snowboard-nordic-cross-country-excellent-spring-wax

// warm rub

// https://www.zumwax.com/products/rub-on-ski-snowboard-nordic-cross-country-wax-great-quick-waxing-on-the-go

//  chill rub

// https://www.zumwax.com/products/ceramic-warm-rub-on-wax

// ceramic warm rub

// https://www.zumwax.com/products/iron-on-ski-snowboard-nordic-ceramic-ultra-performance-speed-block-wax

// speed block














